import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ImageComponent } from '@atoms/image/image.component';
import { ModalMainComponent } from '@molecules/modal/modal-main/modal-main.component';
import { ModalMainContentComponent } from '@molecules/modal/modal-main-content/modal-main-content.component';
import { ModalTitleComponent } from '@molecules/modal/modal-title/modal-title.component';

@Component({
  selector: 'app-photo-uploader-modal',
  imports: [TranslateModule, ImageComponent, ModalMainComponent, ModalMainContentComponent, ModalTitleComponent],
  templateUrl: './photo-uploader-modal.component.html',
  styleUrl: './photo-uploader-modal.component.scss',
})
export class PhotoUploaderModalComponent {}
